import React from "react";

const SBasicMeta = (parent) => {
	const record = parent.record;
	// console.log(record.research_keyword)
	return (
		<div className="mt-px-40">
			<div className="research-area">
				<div className="container">
					<div className="area-list">
						<div className="list-cell">
							<h3 className="detail-title">연구분야 키워드</h3>
							<div className="badge-group">
								{record.research_keyword ?
								<div className="badge-group-inner">
									{record.research_keyword.map((item, index) => {
										return(<span key={index} className="badge badge outline-gray">{item.keyword}</span>)
									})}
								</div>
								: <>입력된 정보가 없습니다.</>}
							</div>
						</div>
						<div className="list-cell">
							<h3 className="detail-title">상세 연구분야</h3>
							<div className="desc">입력된 정보가 없습니다.</div>
						</div>
						<div className="list-cell">
							<h3 className="detail-title">희망 협업분야</h3>
							<div className="desc">입력된 정보가 없습니다.</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SBasicMeta;
